module.exports = __webpack_public_path__ + "img/404-background.4ca6a078.jpg";